import React from "react";

/* Inline 3/4-view wheel-loader (Front-End Loader) SVG.
   Designed at 80x60, scales cleanly. Yellow body, dark cab, black tyres.
   Optional alert tint changes body colour to red.   */
export default function FELMachineIcon({ size = 80, alert = false, paused = false, stale = false, ...rest }) {
    const body = alert ? "#DC2626" : (paused ? "#D97706" : (stale ? "#64748B" : "#F59E0B"));
    const bodyDark = alert ? "#7F1D1D" : (paused ? "#92400E" : (stale ? "#334155" : "#B45309"));
    const cab = alert ? "#7F1D1D" : "#0F172A";
    const cabGlass = "#7DD3FC";
    return (
        <svg
            width={size}
            height={size * 0.75}
            viewBox="0 0 80 60"
            xmlns="http://www.w3.org/2000/svg"
            {...rest}
        >
            {/* Drop shadow */}
            <ellipse cx="40" cy="55" rx="28" ry="3.5" fill="rgba(0,0,0,0.55)" />

            {/* Bucket / blade — front */}
            <path
                d="M 6 36 L 18 30 L 24 30 L 24 44 L 18 50 L 6 44 Z"
                fill={bodyDark}
                stroke="#1f2937"
                strokeWidth="0.6"
            />
            <path d="M 6 36 L 18 30 L 18 44 L 6 44 Z" fill="#374151" opacity="0.7" />

            {/* Front arm */}
            <rect x="22" y="32" width="14" height="5" fill={bodyDark} stroke="#1f2937" strokeWidth="0.6" />

            {/* Chassis */}
            <rect x="32" y="22" width="36" height="22" rx="2" fill={body} stroke="#1f2937" strokeWidth="0.7" />
            {/* Chassis hi-light */}
            <rect x="33" y="23" width="34" height="3" rx="1.5" fill="#FFFFFF" opacity="0.18" />

            {/* Cab */}
            <path
                d="M 40 22 L 42 13 L 58 13 L 60 22 Z"
                fill={cab}
                stroke="#0b1220"
                strokeWidth="0.6"
            />
            {/* Cab window */}
            <path d="M 42 21 L 44 14 L 56 14 L 58 21 Z" fill={cabGlass} opacity="0.85" />

            {/* Engine bay (back) */}
            <rect x="62" y="22" width="8" height="14" rx="1" fill={bodyDark} stroke="#1f2937" strokeWidth="0.5" />

            {/* Hydraulics tube */}
            <rect x="24" y="33" width="10" height="1.5" fill="#1f2937" opacity="0.7" />

            {/* Front tyre */}
            <circle cx="36" cy="46" r="7" fill="#111827" />
            <circle cx="36" cy="46" r="4" fill="#374151" />
            <circle cx="36" cy="46" r="1.5" fill="#9CA3AF" />
            {/* Rear tyre */}
            <circle cx="62" cy="46" r="7" fill="#111827" />
            <circle cx="62" cy="46" r="4" fill="#374151" />
            <circle cx="62" cy="46" r="1.5" fill="#9CA3AF" />

            {/* Brand-stripe */}
            <rect x="36" y="34" width="22" height="2" fill="#FFFFFF" opacity="0.45" />

            {/* Headlight (front of cab) */}
            <circle cx="42" cy="19" r="1.2" fill="#FDE68A" />
        </svg>
    );
}
